export default `
  @font-face {
    font-family: 'Archia';
    src: url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Archia/archia-bold-webfont.eot');
    src: url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Archia/archia-regular-webfont.eot?#iefix') format('embedded-opentype'),
        url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Archia/archia-regular-webfont.woff2') format('woff2'),
        url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Archia/archia-regular-webfont.woff') format('woff'),
        url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Archia/archia-regular-webfont.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Archia';
    src: url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Archia/archia-bold-webfont.eot');
    src: url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Archia/archia-bold-webfont.eot?#iefix') format('embedded-opentype'),
        url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Archia/archia-bold-webfont.woff2') format('woff2'),
        url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Archia/archia-bold-webfont.woff') format('woff'),
        url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Archia/archia-bold-webfont.ttf') format('truetype');
    font-weight: bold;
    font-style: normal;
  }

  @font-face {
    font-family: 'Basier Circle';
    font-weight: normal;
    font-style: normal;
    src: url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Basier/basiercircle-regular.eot');
    src: url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Basier/basiercircle-regular.eot?#iefix') format('embedded-opentype'),
        url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Basier/basiercircle-regular.woff2') format('woff2'),
        url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Basier/basiercircle-regular.woff') format('woff'),
        url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Basier/basiercircle-regular.ttf') format('truetype');
  }

  @font-face {
    font-family: 'Basier Circle';
    font-weight: bold;
    font-style: normal;
    src: url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Basier/basiercircle-bold.eot');
    src: url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Basier/basiercircle-bold.eot?#iefix') format('embedded-opentype'),
        url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Basier/basiercircle-bold.woff2') format('woff2'),
        url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Basier/basiercircle-bold.woff') format('woff'),
        url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Basier/basiercircle-bold.ttf') format('truetype');
  }

  @font-face {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 400;
    src: url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Lato/lato-v16-latin-700.eot'); /* IE9 Compat Modes */
    src: local('Lato Regular'), local('Lato-Regular'),
        url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Lato/lato-v16-latin-regular.woff2') format('woff2'), /* Super Modern Browsers */
        url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Lato/lato-v16-latin-regular.woff') format('woff'), /* Modern Browsers */
        url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Lato/lato-v16-latin-regular.ttf') format('truetype'), /* Safari, Android, iOS */
        url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Lato/lato-v16-latin-regular.svg#Lato') format('svg'); /* Legacy iOS */
  }

  @font-face {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 700;
    src: url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Lato/lato-v16-latin-700.eot'); /* IE9 Compat Modes */
    src: local('Lato Bold'), local('Lato-Bold'),
        url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Lato/lato-v16-latin-700.woff2') format('woff2'), /* Super Modern Browsers */
        url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Lato/lato-v16-latin-700.woff') format('woff'), /* Modern Browsers */
        url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Lato/lato-v16-latin-700.ttf') format('truetype'), /* Safari, Android, iOS */
        url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Lato/lato-v16-latin-700.svg#Lato') format('svg'); /* Legacy iOS */
  }

  @font-face {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 900;
    src: url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Lato/lato-v16-latin-900.eot'); /* IE9 Compat Modes */
    src: local('Lato Black'), local('Lato-Black'),
        url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Lato/lato-v16-latin-900.woff2') format('woff2'), /* Super Modern Browsers */
        url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Lato/lato-v16-latin-900.woff') format('woff'), /* Modern Browsers */
        url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Lato/lato-v16-latin-900.ttf') format('truetype'), /* Safari, Android, iOS */
        url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Lato/lato-v16-latin-900.svg#Lato') format('svg'); /* Legacy iOS */
  }

  @font-face {
    font-family: 'Lora';
    font-style: normal;
    font-weight: 400;
    src: url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Lora/lora-v15-latin-regular.eot'); /* IE9 Compat Modes */
    src: local(''),
        url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Lora/lora-v15-latin-regular.woff2') format('woff2'), /* Super Modern Browsers */
        url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Lora/lora-v15-latin-regular.woff') format('woff'), /* Modern Browsers */
        url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Lora/lora-v15-latin-regular.ttf') format('truetype'), /* Safari, Android, iOS */
        url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Lora/lora-v15-latin-regular.svg#Lora') format('svg'); /* Legacy iOS */
  }

  @font-face {
    font-family: 'Lora';
    font-style: normal;
    font-weight: 700;
    src: url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Lora/lora-v15-latin-700.eot'); /* IE9 Compat Modes */
    src: local(''),
        url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Lora/lora-v15-latin-700.woff2') format('woff2'), /* Super Modern Browsers */
        url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Lora/lora-v15-latin-700.woff') format('woff'), /* Modern Browsers */
        url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Lora/lora-v15-latin-700.ttf') format('truetype'), /* Safari, Android, iOS */
        url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Lora/lora-v15-latin-700.svg#Lora') format('svg'); /* Legacy iOS */
  }

  @font-face {
    font-family: 'Silka mono';
    font-style: normal;
    font-weight: normal;
    src: url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Silka/silkamono-regular.eot'),
        url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Silka/silkamono-regular.eot?#iefix') format('embedded-opentype'),
        url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Silka/silkamono-regular.woff2') format('woff2'), /* Super Modern Browsers */
        url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Silka/silkamono-regular.ttf') format('truetype') /* Safari, Android, iOS */
  }

  @font-face {
    font-family: 'Silka mono';
    font-style: normal;
    font-weight: bold;
    src: url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Silka/silkamono-bold.eot'),
        url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Silka/silkamono-bold.eot?#iefix') format('embedded-opentype'),
        url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Silka/silkamono-bold.woff2') format('woff2'), /* Super Modern Browsers */
        url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Silka/silkamono-bold.ttf') format('truetype') /* Safari, Android, iOS */
  }

  @font-face {
    font-family: 'Jetbrains Mono';
    font-weight: normal;
    font-style: normal;
    src:url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Jetbrains/JetBrainsMono-Regular.woff2') format('woff2'), /* Super Modern Browsers */
    url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Jetbrains/JetBrainsMono-Regular.ttf') format('truetype') /* Safari, Android, iOS */
  }

  @font-face {
    font-family: 'Jetbrains Mono';
    font-weight: bold;
    font-style: normal;
    src:url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Jetbrains/JetBrainsMono-Bold.woff2') format('woff2'), /* Super Modern Browsers */
    url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Jetbrains/JetBrainsMono-Bold.ttf') format('truetype') /* Safari, Android, iOS */
  }

  @font-face {
    font-family: 'Jetbrains Mono';
    font-weight: 800;
    font-style: normal;
    src:url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Jetbrains/JetBrainsMono-ExtraBold.woff2') format('woff2'), /* Super Modern Browsers */
    url('https://helloivy-font.s3.eu-central-1.amazonaws.com/Jetbrains/JetBrainsMono-ExtraBold.ttf') format('truetype') /* Safari, Android, iOS */
  }
`
